<div class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title">{{'Inspection Planner' }}</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <div class="ttmodal__body center" *ngIf="_isLoading" >
      <mat-spinner [color]="warn" [mode]="indeterminate"></mat-spinner>
  </div>
  <div class="ttmodal__body" *ngIf="!_isLoading" >
      <div class="margin-bottom-24">
          <div class="input-group-description">{{'On average how many days is this equipment in use, and on which days? ' }}</div>
          <mat-form-field>
              <input matInput value="0" type="number" [(ngModel)]="equipment.HoursOfUsePerDay" ngDefaultControl required>
              <span matSuffix>{{'Hours per Day'}}</span>
          </mat-form-field>
          <mat-checkbox   [labelPosition]="labelPosition" class="margin-right-16" [(ngModel)]="equipment.UsedMonday" ngDefaultControl>{{'Mon' }}</mat-checkbox>
          <mat-checkbox   [labelPosition]="labelPosition" class="margin-right-16" [(ngModel)]="equipment.UsedTuesday" ngDefaultControl>{{'Tue' }}</mat-checkbox>
          <mat-checkbox   [labelPosition]="labelPosition" class="margin-right-16" [(ngModel)]="equipment.UsedWednesday" ngDefaultControl>{{'Wed' }}</mat-checkbox>
          <mat-checkbox   [labelPosition]="labelPosition" class="margin-right-16" [(ngModel)]="equipment.UsedThursday" ngDefaultControl>{{'Thu' }}</mat-checkbox>
          <mat-checkbox   [labelPosition]="labelPosition" class="margin-right-16" [(ngModel)]="equipment.UsedFriday" ngDefaultControl>{{'Fri'}}</mat-checkbox>
          <mat-checkbox   [labelPosition]="labelPosition" class="margin-right-16" [(ngModel)]="equipment.UsedSaturday" ngDefaultControl>{{'Sat'}}</mat-checkbox>
          <mat-checkbox   [labelPosition]="labelPosition" [(ngModel)]="equipment.UsedSunday" ngDefaultControl>{{'Sun' }}</mat-checkbox>
      </div>
      <div class="margin-bottom-24">
          <div class="input-group-description">{{'How often will you be inspecting this equipment? We will use this to help forecast future inspections. ' }}</div>
          <mat-form-field>
              <input matInput placeholder="{{'I will inspect every' }}" type="number" [(ngModel)]="equipment.InspectEvery" ngDefaultControl required>
          </mat-form-field>
          <mat-form-field>
              <mat-select [(ngModel)]="equipment.InspectEveryUnitTypeId" ngDefaultControl required>
                  <mat-option [value]="unit.Id" *ngFor="let unit of unitList">
                      {{unit.Name }}
                  </mat-option>
              </mat-select>
          </mat-form-field>
      </div>
      <!-- <div class="margin-bottom-24">
          <div class="input-group-description">{{'Do you want to use existing data to forcast next inspection date?' }}</div>
          <mat-checkbox class="margin-right-16" [(ngModel)]="equipment.EnableAutoInspectionPlanner" ngDefaultControl>{{'Enable using exisitng data' }}</mat-checkbox>
          <span *ngIf="equipment.NextInspectionDate != '1900-01-01T00:00:00'" > {{equipment.NextInspectionDate | date : 'dd/MMM/yyyy'}} </span>
      </div> -->
      <!--<div *ngIf="!equipment.EnableAutoInspectionPlanner">
          <div class="margin-bottom-24">{{'What is the next inspection date?'  }}</div>
          <mat-form-field class="input">
              <input matInput [matDatepicker]="myDatepicker" placeholderout="{{}}" [(ngModel)]="equipment.NextInspectionDate">
              <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #myDatepicker></mat-datepicker>
          </mat-form-field>
      </div>-->
  </div>
  <div class="ttmodal__footer">
      <button mat-raised-button (click)="onNoClick()">{{'Cancel' }}</button>
      <button mat-raised-button color="warn" [class.loading]="saving" (click)="updateInspectionPlanner()">
          <span class="material-icons button__icon">check</span>
          <span class="button__text">{{'Save' }}</span>
      </button>
  </div>
</div>